<template>
    <div>
        <!-- <pre>{{ activity }}</pre> -->
        <v-list dense>

            <!-- STATUS -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                        Status
                    </v-list-item-title>

                    <v-chip :color="statusColor" dark small class="mt-1 text-capitalize">
                        {{ activity.status === 'send' ? `sent` : activity.status }}
                    </v-chip>

                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-2" />

            <!-- TITLE -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                        Activity Title
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-1" style="font-size:16px">
                        {{ activity.name_academic }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <!-- TYPE -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                        Activity Type
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-1">
                        {{ activity.activity_type_detail.detail }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-3" />

            <!-- ORGANIZER -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                        Organizer
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ activity.organizer_record }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <!-- SECTOR -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                        Sector
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ activity.sector === 'Nonprofit' ? 'Nonprofit Organization' : activity.sector }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <!-- DATE -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                        Activity Period
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ activity.date_start }} – {{ activity.date_end }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <!-- HOURS -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                        Hours
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ activity.point_activity }} hours
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-3" />

            <!-- FILES -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                        Supporting Documents
                    </v-list-item-title>

                    <v-list dense class="mt-2">
                        <v-list-item v-for="file in activity.files" :key="file.id">
                            <v-list-item-avatar>
                                <v-icon color="red darken-2">
                                    mdi-file-pdf-box
                                </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title>
                                    <a :href="file.file" target="_blank" class="text-decoration-none">
                                        Click here
                                    </a>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-3" />

            <!-- POINT / REMARK -->
            <v-list-item>
                <v-list-item-content class="text-left">

                    <v-list-item-title class="font-weight-bold">
                        Total Points
                    </v-list-item-title>

                    <!-- APPROVE -->
                    <p v-if="activity.status === 'approve'" class="mt-2 mb-0"
                        style="font-size:32px;font-weight:900;color:#2e7d32">
                        {{ activity.point_activity }}
                    </p>

                    <!-- SEND -->
                    <v-alert v-else-if="activity.status === 'send'" type="info" outlined class="mt-3">
                        This activity is currently under review.
                        <br></br>
                        Points will be awarded after approval by the academic staff.
                    </v-alert>

                </v-list-item-content>
            </v-list-item>

        </v-list>
    </div>
</template>

<script>
export default {
    props: {
        activity: { type: Object, required: true }
    },
    computed: {
        statusColor() {
            switch (this.activity.status) {
                case 'approve':
                    return 'green darken-2'
                case 'send':
                    return 'blue darken-2'
                default:
                    return 'grey'
            }
        }
    }
}
</script>
